import request from '@/utils/request'
import requestAuth from '@/utils/requestAuth'

/** A系统(business-pc)外链跳转带来的ask票据，换取本系统登录信息，接口与B系统同一个 */
export function PostAskLogin(data) {
  return request({
    url: 'telecom/getUserInfoByToken',
    method: 'post',
    data
  })
}

/** 获取token */
export function PostToken(data) {
  const dataTemp = `username=${data.userName}&password=${data.passWord}&grant_type=password&scope=all&client_id=client&client_secret=secret`
  return requestAuth({
    url: '/oauth/token',
    method: 'post',
    data: dataTemp
  })
}

/** 拉取取权限 */
export function login(data) {
  return request({
    url: 'login',
    method: 'post',
    data
  })
}
